<template>
    <div>
        <vc-left-menu/>
        <div :class="{
            'layout-content': true,
            'contents-scroll__wrapper': true,
            'is-active': !getMenuToggle }"
        >
            <PerfectScrollbar style="width: 100%; height: 100%">
                <ContentHeader
                    :file-register-name="$t('words.contents_register')"
                    :title="$t('words.contents_list')"
                    :totalProgress="totalProgress"
                    showStorageStatistics
                    @showRegisterModal="showRegisterModal"
                />
                <ContentActionBar
                    :mediaContents="mediaContents"
                    @doRefresh="doRefresh"
                    @loadMediaContents="loadMediaContents"
                />
                <ContentBody
                    :mediaContents="mediaContents"
                    :order="order"
                    @doRemoveMediaContent="doRemoveMediaContent"
                    @doSearch="doSearch"
                    @setOrder="setOrder"
                />
            </PerfectScrollbar>
        </div>

        <MediaContentsUploadModal/>
        <PreviewModal/>
    </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import GlobalConfigMixin from '@/components/mixin/GlobalConfigMixin';
import MediaContentsProgressMixin from '@/components/mixin/MediaContentsProgressMixin';
import ContentHeader from '@/components/cms/common/Content/ContentHeader';
import ContentActionBar from '@/components/cms/common/Content/ContentActionBar';
import ContentBody from '@/components/cms/common/Content/ContentBody';
import MediaContentsUploadModal from '@/components/cms/program/Modal/MediaContentsUploadModal';
import PreviewModal from '@/components/cms/program/Modal/PreviewModal';

const storeModuleName = 'media_contents';

export default {
    components: {
        ContentHeader,
        ContentActionBar,
        ContentBody,
        MediaContentsUploadModal,
        PreviewModal,
    },
    mixins: [
        GlobalConfigMixin,
        MediaContentsProgressMixin,
    ],
    data() {
        return {
            registerModalOpen: false,
            toasted: null,
        };
    },

    computed: {
        ...mapGetters(storeModuleName, [
            'progressIdx',
            'reloadIdx',
            'order',
            'mediaContents',
            'mediaContentsApi',
        ]),
        ...mapGetters('media_contents_upload', ['totalProgress']),
        haveSubmitRight() {
            return this.haveOwnerRight;
        },
        fileRegisterName() {
            return this.totalProgress === null ? this.$t('words.contents_register') : this.$t('words.upload_progress', { progress: this.totalProgress });
        },
    },

    watch: {
        loadedServiceAccount(newValue) {
            this.initialize();
        },
    },

    mounted() {
        $('#registerModal').on('hidden.bs.modal', () => {
            this.doSearch();
        });
        $('#previewModal').on('hidden.bs.modal', () => {
            this.clearPreview();
        });
        this.clearMediaContents();
        if (this.loadedServiceAccount) {
            this.initialize();
        }
    },
    beforeDestroy() {
        if (!_.isNull(this.toasted) && this.toasted !== false) {
            this.toasted.goAway(0);
        }

        $('#registerModal').hide();
        $('.modal-backdrop').remove();
    },
    methods: {
        ...mapMutations({
            setOrder: `${storeModuleName}/setOrder`,
            clearReloadAndProgressIdx: `${storeModuleName}/clearReloadAndProgressIdx`,
            finishUploadInit: `${storeModuleName}/finishUploadInit`,
            clearMediaContents: `${storeModuleName}/clearMediaContents`,
            clearPreview: 'preview/clearPreview',
        }),
        ...mapActions({
            loadMediaContents: `${storeModuleName}/loadMediaContents`,
            doSearch: `${storeModuleName}/doSearch`,
            initializeSearch: `${storeModuleName}/initializeSearch`,
        }),
        showRegisterModal() {
            // this.registerModalOpen = true;
            this.clearReloadAndProgressIdx();
            $('#registerModal').modal({});
        },
        // initialize search
        initialize() {
            this.global_reload_path = 'cms-channels-list';
            this.initializeSearch();
        },
        doRefresh() {
            this.initialize();
        },
        doRemoveMediaContent(mediaContent) {
            if (!this.haveSubmitRight) {
                return;
            }
            if (mediaContent.programs_ready > 0) {
                this.$toasted.error(this.$t('paragraphs.message.error.remove_program_file_ready_schedule'));
                return;
            }
            if (confirm(this.$t('paragraphs.message.confirm.remove_program_file', {
                title: mediaContent.title,
                contents_type: this.$t('words.contents'),
            }))) {
                axios.delete(`/cms/${this.selectedServiceAccount.key}/programs/media_contents`, {
                    data: { selecteds: [{ id: mediaContent.id, upload_file_key: mediaContent.upload_file_key }] },
                }).then(() => {
                    this.$toasted.success(this.$t('paragraphs.message.success.remove_program_file'));
                    this.doSearch();
                }).catch((error) => {
                    this.$toasted.error(this.$t('paragraphs.message.error.remove_program_file'));
                    logger.error(error.response.data.errors);
                });
            }
        },
        finishUpload() {
            this.finishUploadInit();

            $('#registerModal').modal('hide');

            this.doSearch();
        },
    },


};
</script>

<style>
.sortable {
    cursor: pointer;
}
</style>
